export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      platform: filter.platform[0] ? filter.platform : '*',
      arch: filter.arch[0] ? filter.arch : '*',
      status: filter.status[0] ? filter.status : '*',
      isDefaultForNewTenants: filter.isDefaultForNewTenants ?? '*',
      releaseTracks: filter.releaseTracks ?? '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};

export const createMember = user => {
  return {
    fullName: user.requestedByName,
    email: user.requestedByEmail,
    department: user.requestedByRole
  };
};
